export default "__VITE_ASSET__qWyH9jd7__"